import { api, ApiRes } from './client'

interface NyalaCustomer {
    id: string
    is_created: boolean
    explorer_url: string
}

export const getNyalaCustomerVaultData = (naturalProfileId): ApiRes<NyalaCustomer> =>
    api.get('nyala-customers?natural_profile_id=' + naturalProfileId)

export const getNyalaCustomerVaultDataLegal = (legalProfileId): ApiRes<NyalaCustomer> =>
    api.get('nyala-customers?legal_profile_id=' + legalProfileId)

export const checkNyalaPin = (nyalaCustomerId, pin): ApiRes<{ pinValid: boolean }> =>
    api.post(`nyala-customers/${nyalaCustomerId}/check-pin`, { pin: pin })

export const resetNyalaPin = (nyalaCustomerId, pin): ApiRes<{ status: boolean }> =>
    api.post(`nyala-customers/${nyalaCustomerId}/reset-pin`, { pin: pin })
